<template>
  <div>
    <h2 class="m_title solo mt-15 mb-15">{{ $t('component.amended_biblio_details.details')  }}</h2>
    <div>
      <h2 class="m_title back__type">{{ $t('component.amended_biblio_details.reason_of_amendment')  }}</h2>
      <v-row class="ma-0 mt-15">
        <v-col cols="12" class="pt-0 d-flex align-center">
          <v-textarea
            outlined
            class="login_text_filed"
            v-model="notes"
            readonly
          ></v-textarea>
        </v-col>
      </v-row>
    </div>
    <div v-show="amendment.ind_amd_title == 'Y'">
      <h2 class="m_title back__type">{{ $t('component.amended_biblio_details.title')  }}</h2>
      <v-row class="ma-0 mt-25">
        <v-col cols="12" class="pb-0 pa-0">
          <div class="floating__title__self">{{ $t('common.button.before') }}</div>
        </v-col>
        <v-col cols="12" class="pt--10 d-flex align-center" style="border-top:1px solid #222;">
          <label class="nec_title">{{ $t('component.amended_biblio_details.arabic')  }}</label>
          <v-spacer class="hidden_lr10"></v-spacer>
          <div class="input_text_type_basic wp100">
            <v-text-field
              dense
              outlined
              hide-details
              readonly
              class="ft-size12 arabic_align"
              v-model="amendment.title_ar"
            >
            </v-text-field>
          </div>
        </v-col>
        <v-col cols="12" class="pt--10 d-flex align-center">
          <label class="nec_title">{{ $t('component.amended_biblio_details.english')  }}</label>
          <v-spacer class="hidden_lr10"></v-spacer>
          <div class="input_text_type_basic wp100">
            <v-text-field
              dense
              outlined
              hide-details
              readonly
              class="ft-size12 text-left"
              v-model="amendment.title_en"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 mt-25">
        <v-col cols="12" class="pb-0 pa-0">
          <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
        </v-col>
        <v-col cols="12" class="pt--10 d-flex align-center" style="border-top:1px solid #222;">
          <label class="nec_title">{{ $t('component.amended_biblio_details.arabic')  }}</label>
          <v-spacer class="hidden_lr10"></v-spacer>
          <div class="input_text_type_basic wp100">
            <v-text-field
              dense
              outlined
              hide-details
              readonly
              class="ft-size12 text-right"
              v-model="amendment.amend_title_ar"
            >
            </v-text-field>
          </div>
        </v-col>
        <v-col cols="12" class="pt--10 d-flex align-center">
          <label class="nec_title">{{ $t('component.amended_biblio_details.english')  }}</label>
          <v-spacer class="hidden_lr10"></v-spacer>
          <div class="input_text_type_basic wp100">
            <v-text-field
              dense
              outlined
              hide-details
              readonly
              class="ft-size12 text-left"
              v-model="amendment.amend_title_en"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-show="amendment.ind_amd_applcant == 'Y'">
      <h2 class="m_title back__type mt-35">{{ $t('component.amended_biblio_details.applicant2') }}</h2>
      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self">{{ $t('common.button.before') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType1(applicantHeaderTxt, applicantHeaders)"
            :items="beforeApplicantList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td class="text-center">
                  {{ index + 1 }}
                </td>
                <td>
                  <p>{{ item.name_ar }}</p>
                  <p>{{ item.name_en }}</p>
                </td>
                <td>
                  <p>{{ item.address_ar }}</p>
                  <p>{{ item.address_en }}</p>
                </td>
                <td>
                    {{ fnApplicantTypeCodeToName(item.applicant_type_code) }}
                </td>
                <td>
                  {{ item.residence_country_code }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType1(applicantHeaderTxt, applicantHeaders)"
            :items="afterApplicantList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto disabled"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td class="text-center">
                  {{ index + 1 }}
                </td>
                <td>
                  <p>{{ item.name_ar }}</p>
                  <p>{{ item.name_en }}</p>
                </td>
                <td>
                  <p>{{ item.address_ar }}</p>
                  <p>{{ item.address_en }}</p>
                </td>
                <td>
                    {{ fnApplicantTypeCodeToName(item.applicant_type_code) }}
                </td>
                <td>
                  {{ item.residence_country_code }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <div v-show="amendment.ind_amd_inventor == 'Y'">
      <h2 class="m_title back__type mt-35">{{ $t('component.amended_biblio_details.inventor2') }}</h2>
      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self">{{ $t('common.button.before') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType1(inventorHeaderTxt, inventorHeaders)"
            :items="beforeInventorList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  <p>{{ item.name_ar }}</p>
                  <p>{{ item.name_en }}</p>
                </td>
                <td>
                  <p>{{ item.address_ar }}</p>
                  <p>{{ item.address_en }}</p>
                </td>
                <td>
                  {{ item.residence_country_code }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType1(inventorHeaderTxt, inventorHeaders)"
            :items="afterInventorList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto disabled"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  <p>{{ item.name_ar }}</p>
                  <p>{{ item.name_en }}</p>
                </td>
                <td>
                  <p>{{ item.address_ar }}</p>
                  <p>{{ item.address_en }}</p>
                </td>
                <td>
                  {{ item.residence_country_code }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <div v-show="amendment.ind_amd_representative == 'Y'">
      <h2 class="m_title back__type mt-35">{{ $t('component.amended_biblio_details.representative') }}</h2>
      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self">{{ $t('common.button.before') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType1(representativeHeaderTxt, representativeHeaders)"
            :items="beforeRepresentativeList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  <p>{{ item.name_ar }}</p>
                  <p>{{ item.name_en }}</p>
                </td>
                <td>
                  <p>{{ item.address_ar }}</p>
                  <p>{{ item.address_en }}</p>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType1(representativeHeaderTxt, representativeHeaders)"
            :items="afterRepresentativeList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto disabled"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  <p>{{ item.name_ar }}</p>
                  <p>{{ item.name_en }}</p>
                </td>
                <td>
                  <p>{{ item.address_ar }}</p>
                  <p>{{ item.address_en }}</p>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <div v-show="amendment.ind_amd_priority == 'Y'">
      <h2 class="m_title back__type mt-35">{{ $t('component.amended_biblio_details.priority_claim2')  }}</h2>
      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self">{{ $t('common.button.before') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType1(priorityHeaderTxt, priorityHeaders)"
            :items="beforePriorityList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ item.priority_date }}
                </td>
                <td>
                  {{ item.priority_no }}
                </td>
                <td>
                  {{ item.priority_country_code }}
                </td>
                <td>
                  <p class="mt-20 mb--5">
                    <a v-if="fnIsNotNull(item.priority_ar_file_key)" style="text-decoration:none" :href="downLoadUrl + item.priority_ar_file_key">
                      <v-icon>mdi-file-pdf</v-icon>
                      <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                      {{item.priority_ar_file_name}}
                    </a>
                  </p>
                  <p>
                    <a v-if="fnIsNotNull(item.priority_en_file_key)" style="text-decoration:none" :href="downLoadUrl + item.priority_en_file_key">
                      <v-icon>mdi-file-pdf</v-icon>
                      <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                      {{item.priority_en_file_name}}
                    </a>
                  </p>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType1(priorityHeaderTxt, priorityHeaders)"
            :items="afterPriorityList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto disabled"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ item.priority_date }}
                </td>
                <td>
                  {{ item.priority_no }}
                </td>
                <td>
                  {{ item.priority_country_code }}
                </td>
                <td>
                  <p class="mt-20 mb--5">
                    <a v-if="fnIsNotNull(item.priority_ar_file_key)" style="text-decoration:none" :href="downLoadUrl + item.priority_ar_file_key">
                      <v-icon>mdi-file-pdf</v-icon>
                      <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                      {{item.priority_ar_file_name}}
                    </a>
                  </p>
                  <p>
                    <a v-if="fnIsNotNull(item.priority_en_file_key)" style="text-decoration:none" :href="downLoadUrl + item.priority_en_file_key">
                      <v-icon>mdi-file-pdf</v-icon>
                      <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                      {{item.priority_en_file_name}}
                    </a>
                  </p>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <div v-show="amendment.ind_amd_exhibition == 'Y'">
      <h2 class="m_title back__type mt-35">{{ $t('component.amended_biblio_details.temporaryprotection')  }}</h2>
      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self">{{ $t('common.button.before') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType2(temporaryHeaderTxt, temporaryHeadersEn, temporaryHeadersAr)"
            :items="beforeTemporaryList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ item.exhibition_country_code }}
                </td>
                <td v-if="$vuetify.rtl">
                  {{ item.exhibition_name_ar }}
                </td>
                <td v-if="!$vuetify.rtl">
                  {{ item.exhibition_name_en }}
                </td>
                <td>
                  {{ item.opening_date }}
                </td>
                <td>
                  {{ item.protection_date }}
                </td>
                <td>
                  <template v-if="fnIsNotNull(item.certificate_file_key)">
                    <v-icon>mdi-file-pdf</v-icon>
                    <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                    <a style="text-decoration:none" :href="downLoadUrl + item.certificate_file_key">
                      {{item.certificate_file_name}}
                    </a>
                  </template>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="mt-25">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="$getHeaderType2(temporaryHeaderTxt, temporaryHeadersEn, temporaryHeadersAr)"
            :items="afterTemporaryList"
            hide-default-footer
            disable-pagination
            class="elevation-0 myapp_table_type2 type4 overflow-x-auto disabled"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ item.exhibition_country_code }}
                </td>
                <td v-if="$vuetify.rtl">
                  {{ item.exhibition_name_ar }}
                </td>
                <td v-if="!$vuetify.rtl">
                  {{ item.exhibition_name_en }}
                </td>
                <td>
                  {{ item.opening_date }}
                </td>
                <td>
                  {{ item.protection_date }}
                </td>
                <td>
                  <template v-if="fnIsNotNull(item.certificate_file_key)">
                    <v-icon>mdi-file-pdf</v-icon>
                    <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                    <a style="text-decoration:none" :href="downLoadUrl + item.certificate_file_key">
                      {{item.certificate_file_name}}
                    </a>
                  </template>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <div v-show="amendment.ind_amd_abstract == 'Y'">
      <h2 class="m_title back__type mt-35">{{ $t('component.amended_biblio_details.abstract')  }}</h2>
      <v-row class="ma-0 mt-35">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self">{{ $t('common.button.before') }}</div>
        </v-col>
        <v-col cols="12" class="pt--10 d-flex align-center" style="border-top:1px solid #222;">
          <label class="nec_title">{{ $t('component.amended_biblio_details.arabic')  }}</label>
          <v-spacer class="hidden_lr10"></v-spacer>
          <div class="input_text_type_basic wp100">
            <v-textarea
              dense
              outlined
              readonly
              hide-details
              class="ft-size12 arabic_align"
              v-model="amendment.abstract_ar"
            >
            </v-textarea>
          </div>
        </v-col>
        <v-col cols="12" class="pt--10 d-flex align-center">
          <label class="nec_title">{{ $t('component.amended_biblio_details.english')  }}</label>
          <v-spacer class="hidden_lr10"></v-spacer>
          <div class="input_text_type_basic wp100">
            <v-textarea
              dense
              outlined
              readonly
              hide-details
              class="ft-size12 text-left"
              v-model="amendment.abstract_en"
            >
            </v-textarea>
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pb-0">
          <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
        </v-col>
        <v-col cols="12" class="pt--10 d-flex align-center" style="border-top:1px solid #222;">
          <label class="nec_title">{{ $t('component.amended_biblio_details.arabic')  }}</label>
          <v-spacer class="hidden_lr10"></v-spacer>
          <div class="input_text_type_basic wp100">
            <v-textarea
              dense
              outlined
              readonly
              hide-details
              class="ft-size12 arabic_align"
              v-model="amendment.amend_abstract_ar"
            >
            </v-textarea>
          </div>
        </v-col>
        <v-col cols="12" class="pt--10 d-flex align-center">
          <label class="nec_title">{{ $t('component.amended_biblio_details.english')  }}</label>
          <v-spacer class="hidden_lr10"></v-spacer>
          <div class="input_text_type_basic wp100">
            <v-textarea
              dense
              outlined
              readonly
              hide-details
              class="ft-size12 text-left"
              v-model="amendment.amend_abstract_en"
            >
            </v-textarea>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  props : {
    receipt_no : String,
    api_target : String,
    correspondence_show : Boolean
  },
  components :{
  },
  data () {
    return {
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      applicantTypeCodeListAr: [],
      applicantTypeCodeListEn: [],

      amendment : {
        title_ar : '',
        title_en : '',
        abstract_ar : '',
        abstract_en : '',
        amend_title_ar : '',
        amend_title_en : '',
        amend_abstract_ar : '',
        amend_abstract_en : '',
        ind_amd_applcant : 'N',
        ind_amd_inventor : 'N',
        ind_amd_priority : 'N',
        ind_amd_exhibition : 'N',
        ind_amd_representative : 'N',
        ind_amd_title : 'N',
        ind_amd_abstract : 'N',
        ind_amd_correspondence : 'N',
        ind_amd_drawing_ar: 'N',
        ind_amd_drawing_en: 'N'
      },

      applicantHeaderTxt : {
        prefix : 'component.amended_biblio_details.',
        txt : [ '#', 'name','address','applicant_type','residence' ]
      },

      applicantHeaders: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('component.amended_biblio_details.name'), align: 'center', sortable: false, value: '' },
        { text: this.$t('component.amended_biblio_details.address'), align: 'center', sortable: false, value: '' },
        { text: this.$t('component.amended_biblio_details.applicant_type'), align: 'center', sortable: false, value: '' },
        { text: this.$t('component.amended_biblio_details.residence'),  align: 'center', width: '98px', sortable: false, value: '' }
      ],
      beforeApplicantList : [],
      afterApplicantList : [],

      inventorHeaderTxt : {
        prefix : 'component.amended_biblio_details.',
        txt : [ '#', 'name','address','residence' ]
      },

      inventorHeaders: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('component.amended_biblio_details.name'), align: 'center', sortable: false, value: '' },
        { text: this.$t('component.amended_biblio_details.address'), align: 'center', sortable: false, value: '' },
        { text: this.$t('component.amended_biblio_details.residence'),  align: 'center', width: '98px', sortable: false, value: '' }
      ],
      beforeInventorList : [],
      afterInventorList : [],

      representativeHeaderTxt : {
        prefix : 'component.amended_biblio_details.',
        txt : [ '#', 'name','address' ]
      },

      representativeHeaders: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('component.amended_biblio_details.name'), align: 'center', sortable: false, value: '' },
        { text: this.$t('component.amended_biblio_details.address'), align: 'center', sortable: false, value: '' }
      ],
      beforeRepresentativeList : [],
      afterRepresentativeList : [],

      priorityHeaderTxt : {
        prefix : 'component.amended_biblio_details.',
        txt : [ '#', 'filing_date_of_earlier_application','number_of_earlier_application','country','priority_documents' ]
      },

      priorityHeaders: [
        { text: '#', align: 'center', value: 'no', width:'50'},
        { text: this.$t('component.amended_biblio_details.filing_date_of_earlier_application'), sortable: false, align: 'center', value: 'priority_date' },
        { text: this.$t('component.amended_biblio_details.number_of_earlier_application'), sortable: false, align: 'center', value: 'priority_no' },
        { text: this.$t('component.amended_biblio_details.country'), sortable: false, align: 'center', value: 'priority_country_code' },
        { text: this.$t('component.amended_biblio_details.priority_documents'), sortable: false, align: 'center', value: '' }
      ],
      beforePriorityList : [],
      afterPriorityList : [],

      temporaryHeaderTxt : {
        prefix : 'component.amended_biblio_details.',
        txt : [ '#', 'country','exhibition_name','exhibition_opening_date','date_of_protection','attachment' ]
      },

      temporaryHeadersAr: [
        { text: '#', align: 'center', value: 'no', width:'50'},
        { text: this.$t('component.amended_biblio_details.country'), align: 'center', value: 'exhibition_country_code' },
        { text: this.$t('component.amended_biblio_details.exhibition_name'), align: 'center', value: 'exhibition_name_ar' },
        { text: this.$t('component.amended_biblio_details.exhibition_opening_date'), align: 'center', value: 'opening_date' },
        { text: this.$t('component.amended_biblio_details.date_of_protection'), align: 'center', value: 'protection_date' },
        { text: this.$t('component.amended_biblio_details.attachment'), sortable: false, align: 'center', value: '' }
      ],
      temporaryHeadersEn: [
        { text: '#', align: 'center', value: 'no', width:'50'},
        { text: this.$t('component.amended_biblio_details.country'), align: 'center', value: 'exhibition_country_code' },
        { text: this.$t('component.amended_biblio_details.exhibition_name'), align: 'center', value: 'exhibition_name_en' },
        { text: this.$t('component.amended_biblio_details.exhibition_opening_date'), align: 'center', value: 'opening_date' },
        { text: this.$t('component.amended_biblio_details.date_of_protection'), align: 'center', value: 'protection_date' },
        { text: this.$t('component.amended_biblio_details.attachment'), sortable: false, align: 'center', value: '' }
      ],
      beforeTemporaryList : [],
      afterTemporaryList : [],

      target : '',
      ind_correspondence : true,
      notes: ''
    }
  },
  mounted(){
    this.target = utils.isNull(this.api_target) ? '' : '/' + this.api_target

    this.ind_correspondence = utils.isNull(this.correspondence_show) ? true : this.correspondence_show

    this.fnGetApplicantTypeCodeList()

    this.fnGetAmendmentInfo()

    //this.fnGetBeforeApplicantList()
    //this.fnGetAfterApplicantList()

    //this.fnGetBeforeInventorList()
    //this.fnGetAfterInventorList()

    //this.fnGetBeforeRepresentativeList()
    //this.fnGetAfterRepresentativeList()

    this.fnGetBeforePriorityList()
    this.fnGetAfterPriorityList()

    this.fnGetBeforeTemporaryList()
    this.fnGetAfterTemporaryList()

    this.fnGetReceipt()
  },
  methods: {
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.notes = res.data.notes
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetApplicantTypeCodeList(){
      let options = {
        upper_code: '2700'
      }
      utils.fnGetCodeList(options).then(list => {
        this.applicantTypeCodeListAr = list.ar
        this.applicantTypeCodeListEn = list.en
      })
    },
    fnGetAmendmentInfo(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.amendment.title_ar          = res.data.title_ar
            this.amendment.title_en          = res.data.title_en
            this.amendment.abstract_ar       = res.data.abstract_ar
            this.amendment.abstract_en       = res.data.abstract_en
            this.amendment.amend_title_ar    = res.data.amend_title_ar
            this.amendment.amend_title_en    = res.data.amend_title_en
            this.amendment.amend_abstract_ar = res.data.amend_abstract_ar
            this.amendment.amend_abstract_en = res.data.amend_abstract_en

            this.amendment.ind_amd_priority       = res.data.ind_amd_priority
            this.amendment.ind_amd_exhibition     = res.data.ind_amd_exhibition
            this.amendment.ind_amd_representative = 'N'
            this.amendment.ind_amd_title          = res.data.ind_amd_title
            this.amendment.ind_amd_abstract       = res.data.ind_amd_abstract
            this.amendment.ind_amd_applcant       = 'N'
            this.amendment.ind_amd_inventor       = 'N'
            this.amendment.ind_amd_correspondence = 'N'
            this.amendment.ind_amd_drawing_ar = res.data.ind_amd_drawing_ar
            this.amendment.ind_amd_drawing_en = res.data.ind_amd_drawing_en

            this.$emit('amendment', this.amendment)
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAmendmentInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetBeforeApplicantList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/applicants/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.beforeApplicantList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetBeforeApplicantList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAfterApplicantList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.afterApplicantList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAfterApplicantList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetBeforeInventorList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/inventors/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.beforeInventorList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetBeforeInventorList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAfterInventorList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/inventors',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.afterInventorList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAfterInventorList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetBeforeRepresentativeList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/representatives/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.beforeRepresentativeList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetBeforeRepresentativeList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAfterRepresentativeList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/representatives',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.afterRepresentativeList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAfterRepresentativeList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    /* fnGetBeforeCorrespondenceList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/correspondences/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.beforeCorrespondenceList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetBeforeCorrespondenceList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAfterCorrespondenceList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/correspondences',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.afterCorrespondenceList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAfterCorrespondenceList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }, */
    fnGetBeforePriorityList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/priorities/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.beforePriorityList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetBeforePriorityList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAfterPriorityList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/priorities',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.afterPriorityList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAfterPriorityList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetBeforeTemporaryList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/temporaries/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.beforeTemporaryList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetBeforeTemporaryList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAfterTemporaryList(){
      requestApi({
        url: this.target + '/receivings/amendment/' + this.receipt_no + '/temporaries',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.afterTemporaryList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAfterTemporaryList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnApplicantTypeCodeToName(code){
      let codeList = this.$vuetify.rtl ? this.applicantTypeCodeListAr : this.applicantTypeCodeListEn
      let result = code
      for(let i=0; i<codeList.length; i++){
        if(codeList[i].value === code){
          result = codeList[i].text
        }
      }
      return result
    },
    fnIsNotNull(value){
      return !utils.isNull(value)
    },
    getExtIcon(fileName){
      let fileNameArray = fileName.split(".")
      let ext = fileNameArray[fileNameArray.length - 1].toLowerCase()

      if(ext == 'doc' || ext == 'docx'){
        return 'mdi-file-word'
      }else if(ext == 'xlsx' || ext == 'xls'){
        return 'mdi-file-excel'
      }else if(ext == 'ppt' || ext == 'pptx'){
        return 'mdi-file-ppt'
      }else if(ext == 'pdf'){
        return 'mdi-file-pdf'
      }else if(ext == 'png' || ext == 'bmp' || ext == 'rle' || ext == 'dib' ||ext == 'gif' || ext == 'tif' || ext == 'tiff' || ext == 'jpg' ){
        return 'mdi-file-image'
      }else{
        return 'mdi-paperclip'
      }
    }
  }
}
</script>